import { SONY_ADMIN_SCENARIO_IDS } from '@/Config/scenarioIds';
import { AccountDto } from '@/Domain/api/User/dto/Account.dto';
import { PrivilegesEnum } from '@/Domain/enum/Privileges.enum';
import { getCurrentScenarioId } from '@/context';

export const hasSonyAdminAccess = (account: AccountDto | undefined): boolean =>
  SONY_ADMIN_SCENARIO_IDS.includes(getCurrentScenarioId()) &&
  Boolean(account?.privileges.includes(PrivilegesEnum.SONY_ADMIN));
